import { defineStore } from "pinia";
import { Product } from "@/services/api/sdk";
import { computed, ref } from "vue";
import { useApi } from "@/services/api";


export const useCallProductRecommendationsStore = defineStore("call-product-recommendations", () => {
    const products = ref<Product[] | null>(null);
    const queuedProducts = ref<Product[] | null>(null);

    const api = useApi();

    function $reset() {
        products.value = null;
        queuedProducts.value = null;
    }

    async function requestProductList(contactId: number) {
        await api.getContactProductRecommendations({
            contactId,
        });
    }

    function queueProducts(newProducts: Product[]) {
        if (products.value === null) {
            products.value = newProducts;
            return;
        }
        queuedProducts.value = newProducts;
    }

    function showLatestProducts() {
        if (queuedProducts.value === null) {
            return;
        }
        products.value = queuedProducts.value;
        queuedProducts.value = null;
    }

    const hasNewerRecommendation = computed(() => queuedProducts.value !== null);
    const hasProductRecommendation = computed(() => products.value !== null);

    return {
        $reset,
        products,
        queueProducts,
        showLatestProducts,
        hasNewerRecommendation,
        hasProductRecommendation,
        requestProductList,
    };
});
